export default __webpack_public_path__ + "assets/collaboratorSetting.13b38c37.svg";